import { ArrowLeft, FileQuestion } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() { const navigate = useNavigate(); return <div className="page"><div className="state-panel"><FileQuestion size={34} /><h1>Nothing to show here</h1><p>It may have been deleted, or you may not have access.</p><button className="button primary" onClick={() => navigate("/today")}><ArrowLeft size={15} />Back to Today</button></div></div>; }
